var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('Login',{on:{"done":_vm.closeModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }